'use client';

import {useAtomValue} from 'jotai';
import {useParams} from 'next/navigation';
import {PropsWithChildren} from 'react';

import {ALL_APPS_TITLE, ALL_GAMES_TITLE} from '@web-catalog/const';

import {AppType, NO_CATEGORY_CATEGORY} from '@web-catalog/types';

import {categoriesAtom} from '@web-catalog/store';

import {findCategoryData} from '@web-catalog/utils';

import {CategoryViewReporter} from '../CategoryViewReporter/CategoryViewReporter';
import styles from './CategoriesLayout.module.scss';
import {Categories} from './parts/Categories';

type Props = PropsWithChildren<{
  appType: AppType;
}>;

export const CategoriesLayout = ({children, appType}: Props) => {
  const params = useParams();
  const category = typeof params.category === 'string' ? params.category : null;
  const {appsCategories, gamesCategories} = useAtomValue(categoriesAtom);

  const categories =
    appType === AppType.GAMES ? gamesCategories : appsCategories;

  const activeCategory = category
    ? findCategoryData(categories, category)
    : null;

  const title = !activeCategory
    ? category === null
      ? `${appType === AppType.MAIN ? 'Приложения' : 'Игры'}: Интересное`
      : appType === AppType.GAMES
        ? ALL_GAMES_TITLE
        : ALL_APPS_TITLE
    : `${appType === AppType.GAMES ? 'Игры' : 'Приложения'}: ${activeCategory.categoryName}`;

  return (
    <main className={styles.main}>
      <h1 className={styles.title}>{title}</h1>
      <CategoryViewReporter appType={appType} categoryName={category} />
      <Categories
        appType={appType}
        categories={categories}
        activeCategory={
          activeCategory?.category ||
          (category === NO_CATEGORY_CATEGORY ? category : null)
        }
      />
      {children}
    </main>
  );
};
